import React, { useEffect } from "react";

import "./style.scss";
import SpinLoader from "../loader/loader";
import { FaRegCircleXmark } from "react-icons/fa6";

const CustomModal = ({ isLoading, handleClose, children, modalTitle, showCloseIcon }) => {

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === "Escape") {
                handleClose();
            }
        }
        document.addEventListener("keydown", handleKeyDown);
        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        }
    }, [handleClose])

    return (
        <div className="modal-main">
            <div className="modal-main-container">
                <div className="main-container-body">
                    <div className="modal-header-container">
                        <div className="modal-title">{modalTitle ? modalTitle : " "}</div>
                        {showCloseIcon && (<div className="modal-close-icon" onClick={() => handleClose()}><FaRegCircleXmark /></div>)}
                    </div>
                    <div className="modal-body-container">
                        {isLoading && (
                            <div className="loader-container">
                                <SpinLoader />
                            </div>
                        )}
                        {children}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CustomModal;